import React, { useContext, useState } from 'react';
import Layout from '../../Component/layout/main-layout';
import { useTranslation } from 'react-i18next';
import Physical from '../../Component/online-service/electron-filing/physical';
import Juridical from '../../Component/online-service/electron-filing/juridical';
import AppProcedure from '../../Component/online-service/app_procedure';
import layoutBgImg from '../../Images/layout/onlineService.jpg'
import { Context } from '../../Store/context';
import { Post } from '../../api/services/api_helpers';
import GlobalLayout from '../../Component/layout/global-layout';

const ElectronFiling = () => {
    const { t } = useTranslation();
    const [formType, setFormType] = useState('physical');
    const [modalOpen, setModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { showError } = useContext(Context);

    const [data, setData] = useState({
        requester_type: '',
        province: '',
        district: '',
        request_type: '',
        organization_name: '',
        first_name: '',
        last_name: '',
        patronimic: '',
        email: '',
        phone_number: '',
        attachment: null,
        message: '',
        address: '',
        position: ''
    })

    const handlePost = async (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        try {
            const formData = new FormData();
            formData.append('requester_type', data.requester_type);
            formData.append('first_name', data.first_name);
            formData.append('last_name', data.last_name);
            formData.append('patronimic', data.patronimic);
            formData.append('province', data.province);
            formData.append('district', data.district);
            formData.append('request_type', data.request_type);
            formData.append('address', data.address);
            formData.append('email', data.email);
            formData.append('phone_number', data.phone_number);
            formData.append('organization_name', data.organization_name);
            formData.append('position', data.position);
            formData.append('message', data.message);
            if (data.attachment) {
                formData.append('attachment', data.attachment);
            }
            const response = await Post('request/', formData);
            console.log(response);
        } catch (error) {
            showError(error?.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <GlobalLayout
            title={`${t('online_appeals')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Onlaýn ýüztutmalar, Onlayn yuztutmalar, Online yuztutmalar,
                      Online appeals, Онлайн oбращения, Обращения, Ýüztutmalar, 
                      Yuztutmalar, Kazyyete yuztutma"
            >
            <div className='mb-20'>
                <Layout
                    title={t('online_appeals')}
                    layoutBgImg={layoutBgImg}
                />
                <main className='media'>
                    <section className='mt-8 lg:p-8 p-4 bg-white
                                    dark:bg-dark-box'>
                        {/* Top rows */}
                        <div className='relative text-center'>
                            <h1 className='font-bold text-2xl lg:text-4xl text-center 
                                       text-primary dark:text-dark-text'>
                                {t('online_appeals')}
                            </h1>
                            <button className="bg-primary text-white px-4 py-2 
                                           rounded lg:absolute right-0 top-0
                                           mt-4 lg:mt-0"
                                onClick={() => setModalOpen(true)}
                            >
                                {t('application_procedure')}
                            </button>
                            <AppProcedure
                                isOpen={modalOpen}
                                onClose={() => setModalOpen(false)}
                            />
                        </div>

                        {/* Juridical and Physical buttons */}
                        <div className="my-10 flex space-x-2 justify-between lg:justify-start w-full ">
                            <button
                                className={`px-4 py-2 rounded-md font-semibold w-[50%] lg:w-max
                                        ${formType === 'physical' ? 'bg-primary text-white'
                                        : 'bg-secondary text-black'}`}
                                onClick={() => setFormType('physical')}
                            >
                                {t('physical')}
                            </button>
                            <button
                                className={`px-4 py-2 rounded-md font-semibold w-[50%] lg:w-max
                                       ${formType === 'juridic' ? 'bg-primary text-white'
                                        : 'bg-secondary text-black'}`}
                                onClick={() => setFormType('juridic')}
                            >
                                {t('juridical')}
                            </button>
                        </div>
                        {formType === 'physical' &&
                            <Physical
                                data={data} setData={setData}
                                handlePost={handlePost}
                                isLoading={isLoading}
                            />
                        }
                        {formType === 'juridic' &&
                            <Juridical
                                data={data} setData={setData}
                                handlePost={handlePost}
                                isLoading={isLoading}
                            />
                        }
                    </section>
                </main>
            </div>
        </GlobalLayout>
    );
};

export default ElectronFiling;
